import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { AdmPlan } from "@custom-types/base-types";

/** The column definition for the plans table with the field property typed */
export type PlansTableGridColDef = DataGridCellParams<
  AdmPlan,
  PlansTableColumnField
>;

/** The column fields that can be used in the plans table */
export type PlansTableColumnField =
  | "plan"
  | "limits"
  | "status"
  | "assignedTo"
  | "assigneeName"
  | "startDate"
  | "expirationDate"
  | "options";

/** The labels for the columns in the plans table */
export const PLANS_TABLE_COLUMN_LABELS: Record<PlansTableColumnField, string> =
  {
    plan: "Plan",
    limits: "Limits",
    status: "Status",
    assignedTo: "Assigned To",
    assigneeName: "Assignee Name",
    startDate: "Start Date",
    expirationDate: "Expiration Date",
    options: "",
  };
